export default "__VITE_ASSET__x11LFKGr__"